import { MongoDbLocation } from '@shared/types';
import { useQuery, QueryFunction, QueryClient, UseQueryOptions } from '@tanstack/react-query';
import { useMemo } from 'react';

const queryKey = 'POST /locations/by-ids';
type QueryKeys = [typeof queryKey, Array<string>];

export const getLocations = async (locationIds: Array<string>): Promise<Array<MongoDbLocation>> => {
    const response = await fetch(`${process.env.NEXT_PUBLIC_CADEMY_API_URL}/locations/by-ids`, {
        method: 'POST',
        body: JSON.stringify({ locationIds }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};

const getLocationsQueryFunction: QueryFunction<Array<MongoDbLocation>, QueryKeys> = ({
    queryKey,
}) => {
    const [_, locationIds] = queryKey;
    return getLocations(locationIds);
};

export type UseLocationsOptions = Omit<
    UseQueryOptions<Array<MongoDbLocation>, unknown, Array<MongoDbLocation>, QueryKeys>,
    'queryKey' | 'queryFn'
>;
export const useLocations = (locationIds: Array<string>, options?: UseLocationsOptions) => {
    const queryKey: QueryKeys = useMemo(() => {
        return ['POST /locations/by-ids', locationIds];
    }, [locationIds]);
    return useQuery({
        queryKey,
        queryFn: getLocationsQueryFunction,
        ...options,
    });
};

export const preFetchLocations = async (queryClient: QueryClient, locationIds: Array<string>) => {
    const queryKey: QueryKeys = ['POST /locations/by-ids', locationIds];
    return queryClient.prefetchQuery(queryKey, getLocationsQueryFunction);
};
